import { useMemo } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { IFeatureToggle } from './featureToggles.types';
import { parseDrupalFeatureFlagTerms } from './featureToggles.drupal';

/**
 * Toggles turned on by published terms in the Drupal Feature Flags taxonomy
 * (see `featureToggles.drupal.ts`). It is a static query, so the values are
 * fixed at build time and the server render and hydration see the same ones.
 */
export const useDrupalFeatureToggles = (): IFeatureToggle[] => {
    const data = useStaticQuery(graphql`
        query {
            allTaxonomyTermFeatureFlags {
                nodes {
                    name
                    status
                }
            }
        }
    `);
    const terms = data?.allTaxonomyTermFeatureFlags?.nodes;

    return useMemo(() => parseDrupalFeatureFlagTerms(terms).toggles, [terms]);
};
